import { isFeatureEnabledForUser, roleGrantsFullQuoteAccess } from '@carrierbridge/shared';

type AccessUser = Parameters<typeof isFeatureEnabledForUser>[0];

/**
 * La page « Répondre à une cotation » (et son entrée de menu) est-elle ouverte à cette personne ? Deux droits : le module `quoteResponse`
 * (activé par société depuis le superadmin, retirable à une personne) ET la lecture des prix d'achat, que le résultat
 * montre. Même règle que l'API, qui refuse sinon.
 */
export function canAnswerQuoteRequests(user: AccessUser | null | undefined): boolean {
  if (!user) return false;
  return roleGrantsFullQuoteAccess(user.role) && isFeatureEnabledForUser(user, 'quoteResponse');
}
